"use client";

// Global, delegated click tracker for conversion CTAs — one listener instead of
// onClick on every button (most CTAs are server-rendered <Link>s). Fires GA4
// events for "Request access" / pricing / contact-sales clicks fleet-wide on
// askfinz.com. Mark these names as Key events in GA4 to see funnel conversions.
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackEvent } from "@/lib/analytics";

export function ConversionTracker() {
  const pathname = usePathname() ?? "/";

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      const a = target?.closest?.("a") as HTMLAnchorElement | null;
      if (!a) return;
      const href = a.getAttribute("href") || "";
      const label = (a.textContent || "").trim().slice(0, 80);
      const plan = a.getAttribute("data-plan") || undefined;

      if (href.startsWith("/beta")) {
        trackEvent("request_access_click", { page_path: pathname, label, plan });
        if (pathname.startsWith("/pricing")) {
          trackEvent("pricing_cta_click", { page_path: pathname, label, plan });
        }
      } else if (href.startsWith("/contact")) {
        trackEvent("contact_sales_click", { page_path: pathname, label, plan });
        if (pathname.startsWith("/pricing")) {
          trackEvent("pricing_cta_click", { page_path: pathname, label, plan: plan || "contact" });
        }
      }
    };

    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, [pathname]);

  return null;
}
